/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DockCapacities,
  DockCapacitiesParams,
  DockCapacity,
  DockCapacityInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new DockCapacity
 */
export const createDockCapacity = (
    dockCapacityInput: MaybeRefOrGetter<DockCapacityInput>,
 signal?: AbortSignal
) => {
      dockCapacityInput = toValue(dockCapacityInput);

      return axiosClient<DockCapacity>(
      {url: `/dock-capacities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dockCapacityInput, signal
    },
      );
    }




export const getCreateDockCapacityMutationKey = () => ['createDockCapacity'] as const;

export const getCreateDockCapacityMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDockCapacity>>, TError,CreateDockCapacityMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDockCapacity>>, TError,CreateDockCapacityMutationVariables, TContext> => {

const mutationKey = getCreateDockCapacityMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDockCapacity>>, CreateDockCapacityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createDockCapacity(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDockCapacityMutationResult = NonNullable<Awaited<ReturnType<typeof createDockCapacity>>>
    export type CreateDockCapacityMutationBody = DockCapacityInput
    export type CreateDockCapacityMutationError = ErrorType<ValidationError | StandardError>
    export type CreateDockCapacityMutationVariables = {data: DockCapacityInput}

    /**
 * @summary Create new DockCapacity
 */
export const useCreateDockCapacity = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDockCapacity>>, TError,CreateDockCapacityMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDockCapacity>>,
        TError,
        CreateDockCapacityMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDockCapacityMutationOptions(options), queryClient);
    }
    /**
 * @summary DockCapacities list
 */
export const dockCapacities = (
    params?: MaybeRefOrGetter<DockCapacitiesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<DockCapacities>(
      {url: `/dock-capacities`, method: 'GET',
        params, signal
    },
      );
    }




export const getDockCapacitiesQueryKey = (params?: MaybeRefOrGetter<DockCapacitiesParams>,) => {
    return [
    'dock-capacities', ...(params ? [params] : [])
    ] as const;
    }


export const getDockCapacitiesQueryOptions = <TData = Awaited<ReturnType<typeof dockCapacities>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<DockCapacitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockCapacities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDockCapacitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dockCapacities>>> = ({ signal }) => dockCapacities(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dockCapacities>>, TError, TData>
}

export type DockCapacitiesQueryResult = NonNullable<Awaited<ReturnType<typeof dockCapacities>>>
export type DockCapacitiesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary DockCapacities list
 */

export function useDockCapacities<TData = Awaited<ReturnType<typeof dockCapacities>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<DockCapacitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockCapacities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDockCapacitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary DockCapacity destroy
 */
export const destroyDockCapacity = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/dock-capacities/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyDockCapacityMutationKey = () => ['destroyDockCapacity'] as const;

export const getDestroyDockCapacityMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDockCapacity>>, TError,DestroyDockCapacityMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyDockCapacity>>, TError,DestroyDockCapacityMutationVariables, TContext> => {

const mutationKey = getDestroyDockCapacityMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyDockCapacity>>, DestroyDockCapacityMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyDockCapacity(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyDockCapacityMutationResult = NonNullable<Awaited<ReturnType<typeof destroyDockCapacity>>>

    export type DestroyDockCapacityMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyDockCapacityMutationVariables = {id: string}

    /**
 * @summary DockCapacity destroy
 */
export const useDestroyDockCapacity = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDockCapacity>>, TError,DestroyDockCapacityMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyDockCapacity>>,
        TError,
        DestroyDockCapacityMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyDockCapacityMutationOptions(options), queryClient);
    }
    /**
 * @summary Get DockCapacity
 */
export const dockCapacity = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<DockCapacity>(
      {url: `/dock-capacities/${id}`, method: 'GET', signal
    },
      );
    }




export const getDockCapacityQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'dock-capacities',id
    ] as const;
    }


export const getDockCapacityQueryOptions = <TData = Awaited<ReturnType<typeof dockCapacity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockCapacity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDockCapacityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dockCapacity>>> = ({ signal }) => dockCapacity(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dockCapacity>>, TError, TData>
}

export type DockCapacityQueryResult = NonNullable<Awaited<ReturnType<typeof dockCapacity>>>
export type DockCapacityQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get DockCapacity
 */

export function useDockCapacity<TData = Awaited<ReturnType<typeof dockCapacity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockCapacity>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDockCapacityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update DockCapacity
 */
export const updateDockCapacity = (
    id: MaybeRefOrGetter<string>,
    dockCapacityInput: MaybeRefOrGetter<DockCapacityInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
dockCapacityInput = toValue(dockCapacityInput);

      return axiosClient<DockCapacity>(
      {url: `/dock-capacities/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: dockCapacityInput, signal
    },
      );
    }




export const getUpdateDockCapacityMutationKey = () => ['updateDockCapacity'] as const;

export const getUpdateDockCapacityMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDockCapacity>>, TError,UpdateDockCapacityMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDockCapacity>>, TError,UpdateDockCapacityMutationVariables, TContext> => {

const mutationKey = getUpdateDockCapacityMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDockCapacity>>, UpdateDockCapacityMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateDockCapacity(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDockCapacityMutationResult = NonNullable<Awaited<ReturnType<typeof updateDockCapacity>>>
    export type UpdateDockCapacityMutationBody = DockCapacityInput
    export type UpdateDockCapacityMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateDockCapacityMutationVariables = {id: string;data: DockCapacityInput}

    /**
 * @summary Update DockCapacity
 */
export const useUpdateDockCapacity = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDockCapacity>>, TError,UpdateDockCapacityMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateDockCapacity>>,
        TError,
        UpdateDockCapacityMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDockCapacityMutationOptions(options), queryClient);
    }
